<template>
  <ul class="root">
    <li v-for="(item, index) in data" :key="index">
      <a :href="item?.link" :target="target">
        {{ item?.name }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    target: {
      type: String,
      default: "_blank",
    },
  },
};
</script>

<style scoped>
.root {
  display: flex;
  flex-wrap: wrap;

  margin: 0;
  padding: 0;

  list-style: none;
  color: var(--color-success-active);
}

.root li:not(:last-child):after {
  content: ", ";

  margin-left: 2px;
}

.root li a {
  color: inherit;
}
</style>
